import { useMutation, useQuery, useQueryClient } from "react-query";
import { createLeaveBalance, deleteLeaveBalance, fetchLeaveBalances, updateLeaveBalance, } from "@/features/leaveBalance/services/leaveBalanceService";
const useLeaveBalances = (page = 1, filters = {}, limit = 10) => {
    const queryClient = useQueryClient();
    const queryKey = ["leaveBalances", { page, filters, limit }];
    const { data, error, isLoading, refetch } = useQuery(queryKey, () => fetchLeaveBalances(page, filters, limit), {
        keepPreviousData: true,
        staleTime: 60000,
    });
    const createMutation = useMutation((payload) => createLeaveBalance(payload), {
        onSuccess: () => queryClient.invalidateQueries(["leaveBalances"]),
    });
    const updateMutation = useMutation(({ id, balance }) => updateLeaveBalance(id, balance), {
        onSuccess: () => queryClient.invalidateQueries(["leaveBalances"]),
    });
    const deleteMutation = useMutation((id) => deleteLeaveBalance(id), {
        onSuccess: () => queryClient.invalidateQueries(["leaveBalances"]),
    });
    return {
        leaveBalances: data?.leaveBalances ?? [],
        meta: data?.meta ?? null,
        isLoading,
        error: error ? error.message : null,
        refetch,
        createBalance: createMutation.mutateAsync,
        updateBalance: updateMutation.mutateAsync,
        deleteBalance: deleteMutation.mutateAsync,
    };
};
export default useLeaveBalances;
